"use client";

/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
import classnames from "classnames";
import Dropdown from "component/react-bootstrap/Dropdown";
import Menu from "component/react-bootstrap/DropdownMenu";
import Toggle from "component/react-bootstrap/DropdownToggle";
import MenuItem from "component/react-bootstrap/MenuItem";
import VehicleIcon from "modules/home/VehicleIcon";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { Component } from "react";
import { connect } from "react-redux";
import { ExponentLabel } from "../design-system/shared-styles/ExponentLabel";
import styles from "./garageDropdown.module.scss";

const GarageList = dynamic(() => import(/* webpackChunkName: "garage-list" */ "component/garage-list/garage-list.component"), {
  ssr: false,
});

const mapStateToProps = (state: any) => ({
  garage: state.garage,
});

class GarageDropdown extends Component {
  static propTypes = {
    dropdownComponentClass: PropTypes.func,
    toggleButtonClassName: PropTypes.string,
    dropdownId: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    onAddVehicleClick: PropTypes.func.isRequired,
    menuPullRight: PropTypes.bool,
    menuFullWidth: PropTypes.bool,
    showDropdownArrow: PropTypes.bool,
    showVehicleCount: PropTypes.bool,
    darkIcon: PropTypes.bool,
  };

  static defaultProps = {
    menuPullRight: false,
    menuFullWidth: false,
    showDropdownArrow: false,
    showVehicleCount: false,
    darkIcon: false,
  };

  constructor(props: any) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleHandler = (isOpen: boolean) => {
    const { callBack } = this.props;
    if (callBack) {
      if (isOpen) {
        callBack(false);
      } else {
        callBack(false, true);
      }
    }
    this.setState({ isOpen });
  };

  render() {
    const {

      dropdownComponentClass,

      dropdownId,

      buttonText,

      onAddVehicleClick,

      toggleButtonClassName,

      menuPullRight,

      menuFullWidth,

      showDropdownArrow,

      showVehicleCount,

      garage,

      darkIcon = false,
      loc,
      dropdownMenuClass = "",
      applyGarageDropdownClass = false,
      onChangeVehicle,
    } = this.props;

    const { isOpen } = this.state;

    return (
      <Dropdown
        open={this.state.isOpen}
        componentClass={dropdownComponentClass}
        id={dropdownId}
        onToggle={this.toggleHandler}
        pullRight={menuPullRight}
      >
        <Toggle
          aria-label="Garage Dropdown"
          className={`${applyGarageDropdownClass ? styles.garage_dropdown : ""} ${toggleButtonClassName} d-flex align-items-center justify-content-center`}
        >
          <div className="toggle-btn-title d-flex align-items-center">
            <VehicleIcon dark={darkIcon} />

            {showVehicleCount && garage.vehicles.length > 0 && (
              <ExponentLabel style={{ top: "calc(0.2 * var(--safari-root-font, 10px))" }}>
                {garage.vehicles.length}
              </ExponentLabel>
            )}

            <span className="m-l-10 vehicle-name text-uppercase">
              {buttonText}
            </span>
          </div>
        </Toggle>

        <Menu className={classnames(dropdownMenuClass, { "menu-full-width": menuFullWidth })}>

          {showDropdownArrow && <div className="arrow-up" />}
          {isOpen && (
            <MenuItem>

              <div className="garage-list-container">

                <GarageList
                  onClose={() => this.setState({ isOpen: false })}
                  onAddVehicleClick={onAddVehicleClick}
                  isOpen={isOpen}
                  loc={loc}
                  onChangeVehicle={onChangeVehicle}
                />
              </div>
            </MenuItem>
          )}
        </Menu>
      </Dropdown>
    );
  }
}

export default connect(mapStateToProps, null)(GarageDropdown);
